export const Home = {
  "Sider": {
    "OpenFile": "Open File",
    "Home": "Home",
    "Shared": "Shared",
    "ESignAgreements": "eSign agreements",
    "New": "New",
    "Template": "Template",
    "Tutorials": "Tutorials",
    "EsignDoc": "Signing Record",
    "trial5Day": "Your {dayNum}-day free trial has been activated. Enjoy all the features of our browser-based PDF editor.",
    "Purchase": "Subscribe",
    "DaysIntrial": "Days left in trial",
    "TrialEnds": "Your Free Trial has expired",
    "subscribeExpired": "Your subscription has expired",
    "Premium": "Try out our Premium Features",
    "FreeTrial": "Free Trial",
    "BuyNow": "Buy Now",
    "TermsUpdateNotice": "We recently updated our Terms of Service and Privacy Policy. By continuing to use Foxit PDF Editor Cloud, you agree to these updates.",
    "Start": "Start",
    "Documents": "Cloud Documents",
    "CreateBlankPDF": "Create Blank PDF",
    "Upgrade": "Upgrade"
  },
  "Header": {
    "Title": "<span class=\"main-title\">Welcome to PDF Editor Cloud!</span><span class=\"sub-tip\">(Choose the scene to use)</span>"
  },
  "Start": {
    "Title": "Welcome to PDF Editor Cloud!"
  },
  "Tour": {
    "Title": "Take a tour",
    "Of": "of",
    "Skip": "Skip",
    "Next": "Next",
    "Over": "Over",
    "Done": "Done",
    "DiscoverMore": {
      "Title": "Discover more",
      "Descript": "Discover more about PDF features, work on the desktop, and more."
    },
    "ChooseFile": {
      "Title": "Choose File",
      "Descript": "Open a file from your computer or online storage account to start your work."
    },
    "ShareFile": {
      "Title": "Share a file",
      "Descript": "Collaborate on PDFs by sharing through emails or links."
    },
    "OpenFile": {
      "Title": "Open File",
      "Descript": "Open a file from your computer or online storage account to start your work. You can disable uploading documents to Cloud Documents in Preferences."
    },
    "Documents": {
      "Title": "Cloud Documents",
      "Descript": "Manage documents in Cloud Documents. Collaborate on PDFs by sharing through emails or links."
    }
  }
}